// Literal Tailwind class lookups for every step in the `spacing-ref-*` scale
// exposed by `@latitude/design-system`'s `config.spacing`. Values are spelled
// out (not template-generated) so Tailwind's JIT scanner can see them as
// literal strings in this file — see design.md decision D2.
//
// Keep in lockstep with `config.spacing` from `@latitude/design-system`;
// spacing.lockstep.test.ts fails if the token scale adds/removes a step this
// file doesn't cover.

export const GAP = {
  0: 'gap-spacing-ref-none',
  2: 'gap-spacing-ref-xxtiny',
  4: 'gap-spacing-ref-xtiny',
  6: 'gap-spacing-ref-tiny',
  8: 'gap-spacing-ref-xsmall',
  12: 'gap-spacing-ref-small',
  16: 'gap-spacing-ref-default',
  20: 'gap-spacing-ref-medium',
  24: 'gap-spacing-ref-large',
  32: 'gap-spacing-ref-xlarge',
  40: 'gap-spacing-ref-xxlarge',
  48: 'gap-spacing-ref-big',
  64: 'gap-spacing-ref-huge',
} as const;

export const COLUMN_GAP = {
  0: 'gap-x-spacing-ref-none',
  2: 'gap-x-spacing-ref-xxtiny',
  4: 'gap-x-spacing-ref-xtiny',
  6: 'gap-x-spacing-ref-tiny',
  8: 'gap-x-spacing-ref-xsmall',
  12: 'gap-x-spacing-ref-small',
  16: 'gap-x-spacing-ref-default',
  20: 'gap-x-spacing-ref-medium',
  24: 'gap-x-spacing-ref-large',
  32: 'gap-x-spacing-ref-xlarge',
  40: 'gap-x-spacing-ref-xxlarge',
  48: 'gap-x-spacing-ref-big',
  64: 'gap-x-spacing-ref-huge',
} as const;

export const ROW_GAP = {
  0: 'gap-y-spacing-ref-none',
  2: 'gap-y-spacing-ref-xxtiny',
  4: 'gap-y-spacing-ref-xtiny',
  6: 'gap-y-spacing-ref-tiny',
  8: 'gap-y-spacing-ref-xsmall',
  12: 'gap-y-spacing-ref-small',
  16: 'gap-y-spacing-ref-default',
  20: 'gap-y-spacing-ref-medium',
  24: 'gap-y-spacing-ref-large',
  32: 'gap-y-spacing-ref-xlarge',
  40: 'gap-y-spacing-ref-xxlarge',
  48: 'gap-y-spacing-ref-big',
  64: 'gap-y-spacing-ref-huge',
} as const;

export const PADDING = {
  0: 'p-spacing-ref-none',
  2: 'p-spacing-ref-xxtiny',
  4: 'p-spacing-ref-xtiny',
  6: 'p-spacing-ref-tiny',
  8: 'p-spacing-ref-xsmall',
  12: 'p-spacing-ref-small',
  16: 'p-spacing-ref-default',
  20: 'p-spacing-ref-medium',
  24: 'p-spacing-ref-large',
  32: 'p-spacing-ref-xlarge',
  40: 'p-spacing-ref-xxlarge',
  48: 'p-spacing-ref-big',
  64: 'p-spacing-ref-huge',
} as const;

export const PADDING_X = {
  0: 'px-spacing-ref-none',
  2: 'px-spacing-ref-xxtiny',
  4: 'px-spacing-ref-xtiny',
  6: 'px-spacing-ref-tiny',
  8: 'px-spacing-ref-xsmall',
  12: 'px-spacing-ref-small',
  16: 'px-spacing-ref-default',
  20: 'px-spacing-ref-medium',
  24: 'px-spacing-ref-large',
  32: 'px-spacing-ref-xlarge',
  40: 'px-spacing-ref-xxlarge',
  48: 'px-spacing-ref-big',
  64: 'px-spacing-ref-huge',
} as const;

export const PADDING_Y = {
  0: 'py-spacing-ref-none',
  2: 'py-spacing-ref-xxtiny',
  4: 'py-spacing-ref-xtiny',
  6: 'py-spacing-ref-tiny',
  8: 'py-spacing-ref-xsmall',
  12: 'py-spacing-ref-small',
  16: 'py-spacing-ref-default',
  20: 'py-spacing-ref-medium',
  24: 'py-spacing-ref-large',
  32: 'py-spacing-ref-xlarge',
  40: 'py-spacing-ref-xxlarge',
  48: 'py-spacing-ref-big',
  64: 'py-spacing-ref-huge',
} as const;

export type SpacingStep = keyof typeof GAP;
